if (!customElements.get('view-switch')) {
  class ViewSwitch extends HTMLElement {
    constructor() {
      super();
      this.Element = this;
      this.Settings = true;
      this.Toggles = this.Element.querySelectorAll('[data-toggle="view"]');
      this.Container = document.querySelector([...this.Toggles].first.hash);
      this.init();
    }
    
    init() {
      if (this.Toggles.length < 1) {
        console.warn('No element found that could be used as a view switch handle.');
        return false;
      }

      for (let toggle of this.Toggles) {
        toggle.on('click', evt => {
          evt.preventDefault();
          this.current = toggle.dataset.view;
        });
      }

      if (this.Settings.rememberView) { this.current = localStorage.getItem('view'); }
    }

    get current() { return this._current || this.Container.dataset.view; }
    set current(val) {
      let clicked = [...this.Toggles].find(t => t.dataset.view === val);
      if (!clicked) { return false; }
      if (clicked.getAttribute('aria-current').toBoolean()) { return true; }
      clicked.setAttribute('aria-current', true);
      clicked.setAttribute('aria-selected', true);

      let others = [...this.Toggles].filter(t => t.dataset.view !== val);
      if (!others.length) { return false; }
      others.forEach(t => {
        t.setAttribute('aria-current', false);
        t.setAttribute('aria-selected', false);
      });

      this.Container.dataset.view = this._current = val;
      if (this.Settings.rememberView) { this.current = localStorage.setItem('view', val); }
    }
  }
  customElements.define('view-switch', ViewSwitch);
}